import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Row, Col, Card, Form, Button, Modal, Select, Input } from 'antd'
import { FilterFilled } from '@ant-design/icons'
import FilterList from './regimen.filterlist'
import _ from 'lodash'
import '../../css/patient.scss'
import { getRegimens } from '../../store/action/regimen.action'

var form = null

const RegimenFilter = (props) => {
  const [open, setOpen] = useState(false)

  var onFinish = (data) => {
    form.validateFields().then((data) => {
      props.fetchRegimens({filter:data,companyid:props.customer.company,customerid:props.customer._id})
      setOpen(false)
    })
  }

  var handleClearFilter = () => {
    props.fetchRegimens({ filter: {}, companyid: props.customer.company, customerid: props.customer._id })
    form && form.resetFields()
  }

  var handleModalOpen = () => {
    form && form.setFieldsValue(props.filters)
    setOpen(true)
  }

  var renderCard = () => {
    return (
      <Card bordered={false}>
        <Form
          ref={(e) => (form = e)}
          name='normal_login'
          labelCol={{ span: 5 }}
        >
          <Form.Item name='surgery_type' label='Surgery type'>
            <Select
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              mode='multiple'
              placeholder='Select surgery type'
            >
              <Select.Option value='hip'>Hip</Select.Option>
              <Select.Option value='knee'>Knee</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item name='age_group' label='Age group'>
            <Select
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              mode='multiple'
              placeholder='Select age group'
            >
              <Select.Option value='30-40'>30-40</Select.Option>
              <Select.Option value='41-50'>41-50</Select.Option>
              <Select.Option value='51-60'>51-60</Select.Option>
              <Select.Option value='61-70'>61-70</Select.Option>
              <Select.Option value='71-80'>71-80</Select.Option>
              <Select.Option value='81+'>81+</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item name='gender' label='Gender'>
            <Select
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              mode='multiple'
              placeholder='Select gender'
            >
              <Select.Option value='male'>Male</Select.Option>
              <Select.Option value='female'>Female</Select.Option>
            </Select>
          </Form.Item>
        </Form>
      </Card>
    )
  }

  return (
    <>
      <Row className='filterRow' align={'end'}>
        <Col flex={'auto'}>
          <FilterList />
        </Col>
        <Col flex={'30%'}>
          <Row justify={'end'}>
            <Button
              className={'clearBtn'}
              type='primary'
              onClick={handleClearFilter}
              disabled={props.filters && Object.keys(props.filters).length <= 1}
            >
              Clear Filter
            </Button>
            <FilterFilled className={'filterIcon'} onClick={handleModalOpen} />
          </Row>
        </Col>
      </Row>
      <Modal
        className={'filterModal'}
        visible={open}
        closable={false}
        maskClosable={false}
        width={'40%'}
        okText={'Filter'}
        onOk={onFinish}
        onCancel={() => setOpen(false)}
      >
        {renderCard()}
      </Modal>
    </>
  )
}

RegimenFilter.propTypes = {
  customer: PropTypes.object,
  filters: PropTypes.object,
}

const mapStateToProps = (state) => {
  return {
    customer: state.profile.customer,
    filters: state.regimen.filters,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchRegimens: (filters) => dispatch(getRegimens(filters)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RegimenFilter)
